<template>
  <div class="search-container" :class="{'menu-showing' : isSearchMenuMobileShowing}">
    <div class="search" v-click-outside="onClose">
      <multiselect
        :disabled="disabled"
        :value="value"
        :options="data"
        :selectLabel="selectLabel"
        :placeholder="placeholder"
        :deselectLabel="deselectLabel"
        :customLabel="customLabel"
        @open="onSearchChange"
        @search-change="onSearchChange"
        @select="onSelected"
        class="search-desktop">
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <span class="option__title">{{ props.option.title }}</span>
          </div>
        </template>
        <template slot="noOptions">
          <span>Try to search something...</span>
        </template>
        <template slot="noResult">
          <span>Your search for <strong>'{{value}}'</strong> had 0 results.</span>
        </template>
      </multiselect>
    </div>
    <button type="button" class="btn btn-link search-mobile" @click.stop="onToggleMenu()">
      <i class="fas fa-search"></i>
    </button>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ClickOutside from 'vue-click-outside';
import generateLink from '@/utils/generateLink';

export default {
  mixins: [generateLink],
  directives: {
    ClickOutside,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      isSearchMenuMobileShowing: false,
      selectLabel: '',
      deselectLabel: '',
      placeholder: 'Search Video',
    };
  },
  methods: {
    customLabel(option) {
      return option.title;
    },
    onSelected(selectedOption) {
      this.$emit('onSelectedSearchResult', selectedOption);
    },
    onClose() {
      this.isSearchMenuMobileShowing = false;
    },
    onToggleMenu() {
      this.isSearchMenuMobileShowing = !this.isSearchMenuMobileShowing;
    },
    onSearchChange(searchQuery) {
      this.$emit('input', searchQuery);
      this.onChange(searchQuery);
    },
  },
};
</script>

<style lang="scss">
@import '~vue-multiselect/dist/vue-multiselect.min.css';
@import '@/assets/scss/variables.scss';


.search-container {
  min-width: 600px;
  .search-mobile {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .search-container {
    min-width: auto;
    transition: all 0.2s ease-out;

    .search-desktop {
      display: none;
    }

    .search-mobile {
      display: block;
      color: white;
      // color: white;
      // background: $primary;
      font-size: $font-size-base * 1.25;
    }

    &.menu-showing {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.85);
      z-index: 900;
      padding: $spacer * 2 $spacer;

      .search-desktop {
        display: block;
      }

      .search-mobile {
        display: none;
      }
    }
  }
}


// custom style lib

.multiselect__input, .multiselect__single, .multiselect__tags, .multiselect__option {
  font-size: $font-size-base;
  // background-color: darken($secondary, 10%);
  background-color: $gray-300;
  color: $gray-600;
  border: none;
}

.multiselect__select {
  // background: url(~@/assets/image/search.png) no-repeat scroll 50% 50%;

  .option__desc {

    .option__title {

    }

    .option__small {
      color: $gray-500;
    }
  }
}

.multiselect__placeholder {
  color: $gray-500;
}

.multiselect--active {
  height: 43px;
  .multiselect__select {
    transform: unset;
  }
}

.multiselect__option--highlight {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: none;
  color: $body-color;
}

.multiselect__select:before {
  content: none;
}

</style>
